/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_New_SubInputs */

const en_recipes_new_sub = /** @type {(inputs: Recipes_New_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imported, not reviewed yet`)
};

const de_recipes_new_sub = /** @type {(inputs: Recipes_New_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importiert, noch nicht geprüft`)
};

/**
* | output |
* | --- |
* | "Imported, not reviewed yet" |
*
* @param {Recipes_New_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_new_sub = /** @type {((inputs?: Recipes_New_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_New_SubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_new_sub(inputs)
	return en_recipes_new_sub(inputs)
});